import { TourProvider, useTour } from "@reactour/tour";
import App from "../App/App";
import { useLocation } from "react-router-dom";
import { createContext, useEffect, useMemo, useState } from "react";
import {
  appointmentSteps,
  carsChartSteps,
  carsInWorkSteps,
  carsListSteps,
  clientInfoModalSteps,
  commercialOfferSteps,
  createRecordSteps,
  createServiceSteps,
  diagnosticPartSteps,
  generalInfoInWorkSteps,
  incomeModalSteps,
  notificationSteps,
  orderSteps,
  paymentModalsSteps,
  periodSelectorSteps,
  plannerSteps,
  receivedSteps,
  repairSteps,
  serviceLoadChartSteps,
  settingsSteps,
  settingsStepsCashRegisters,
  settingsStepsPosts,
  settingsStepsPrice,
  settingsStepsStaff,
  settingsStepsSuppliers,
  settingsStepsWarehouse,
  stepsSchedule,
  videoControlStepsCameras,
  videoControlStepsStatistic,
} from "../../utils/steps";
import PulseHighlighter from "../NavigationBottom/TutorialNav/PulseHighlighter/PulseHighlighter";
import { useSelector } from "react-redux";
import {
  selectLegalPersonType,
  selectTutorialPage,
} from "../../redux/settings/selectors";
import { useDispatch } from "react-redux";
import TutorialStarter from "./TutorialStarter";

export default function TourManager(params) {
  const location = useLocation();
  const section = useSelector(selectTutorialPage);
  const dispatch = useDispatch();
  const { setSteps, setCurrentStep, steps } = useTour();

  const stepsArray = useMemo(() => {
    if (location.pathname === "/settings" && section === "create-service")
      return createServiceSteps;
    if (location.pathname === "/settings" && section === "services")
      return settingsSteps;
    if (location.pathname === "/settings" && section === "suppliers")
      return settingsStepsSuppliers(dispatch);
    if (location.pathname === "/settings" && section === "posts")
      return settingsStepsPosts(dispatch);
    if (location.pathname === "/settings" && section === "staff")
      return settingsStepsStaff(dispatch);
    if (location.pathname === "/settings" && section === "price")
      return settingsStepsPrice(dispatch);
    if (location.pathname === "/settings" && section === "warehouse")
      return settingsStepsWarehouse(dispatch);
    if (location.pathname === "/settings" && section === "cashRegisters")
      return settingsStepsCashRegisters(dispatch);
    if (location.pathname === "/settings" && section === "schedule")
      return stepsSchedule;
    if (location.pathname === "/video-control" && section === "statistic")
      return videoControlStepsStatistic;
    if (location.pathname === "/video-control" && section === "cameras")
      return videoControlStepsCameras;
    if (
      location.pathname === "/video-control" &&
      section === "service-load-chart"
    )
      return serviceLoadChartSteps;
    if (location.pathname === "/video-control" && section === "cars-chart")
      return carsChartSteps;
    if (location.pathname === "/video-control" && section === "cars-in-work")
      return carsInWorkSteps;
    if (location.pathname === "/crm" && section === "planner")
      return plannerSteps;
    if (location.pathname === "/crm" && section === "period-selector")
      return periodSelectorSteps;
    if (location.pathname === "/crm" && section === "cars-list")
      return carsListSteps;
    if (location.pathname === "/crm" && section === "create-record")
      return createRecordSteps;
    if (
      location.pathname === "/accounting/clients" &&
      section === "general-info"
    )
      return generalInfoInWorkSteps;
    if (location.pathname === "/accounting/clients" && section === "diag-modal")
      return diagnosticPartSteps;
    if (
      location.pathname === "/accounting/clients" &&
      section === "appointment-modal"
    )
      return appointmentSteps;
    if (location.pathname === "/accounting/clients" && section === "co-modal")
      return commercialOfferSteps;
    if (
      location.pathname === "/accounting/clients" &&
      section === "prepayment-modal"
    )
      return paymentModalsSteps;

    if (
      location.pathname === "/accounting/clients" &&
      section === "client-payment-modal"
    )
      return incomeModalSteps;
    if (
      location.pathname === "/accounting/clients" &&
      section === "clientInfo-modal"
    )
      return clientInfoModalSteps;
    if (
      location.pathname === "/accounting/clients" &&
      section === "order-modal"
    )
      return orderSteps;
    if (
      location.pathname === "/accounting/clients" &&
      section === "received-modal"
    )
      return receivedSteps;
    if (
      location.pathname === "/accounting/clients" &&
      section === "repair-modal"
    )
      return repairSteps;
    if (
      location.pathname === "/accounting/clients" &&
      section === "notification-modal"
    )
      return notificationSteps;

    return [];
  }, [location.pathname, section]);

  // console.log(location.pathname);
  // console.log(section);

  useEffect(() => {
    setSteps(stepsArray); // оновлюємо кроки
    setCurrentStep(0); // повертаємося на перший крок
  }, [stepsArray, section, location.pathname]);

  return (
    // <TourProvider
    //   // key={`${location?.pathname}-${section}`}
    //   steps={[]}
    //   showCloseButton={false}
    //   showNavigation={false}
    //   showDots={false}
    //   showBadge={false}
    // >
    <>
      <TutorialStarter stepsArray={steps} />
      <PulseHighlighter steps={steps} />
    </>
    //   <App />
    // </TourProvider>
  );
}
